import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=22487a74&scoped=true&"
import script from "./subscriptions.vue?vue&type=script&lang=js&"
export * from "./subscriptions.vue?vue&type=script&lang=js&"
import style0 from "./subscriptions.vue?vue&type=style&index=0&id=22487a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22487a74",
  null
  
)

export default component.exports